import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Header from './components/header.js';
import Footer from './components/footer.js';
import './Photography.css';

class Photography extends Component {
  constructor(props) {
    super(props);
    this.state = {
      galleries: [],
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    fetch('/galleries.json')
      .then(r => {
        if (!r.ok) throw new Error(`Could not load galleries (HTTP ${r.status})`);
        return r.json();
      })
      .then(data => this.setState({ galleries: data, loading: false }))
      .catch(err => this.setState({ error: err.message, loading: false }));
  }

  render() {
    const { galleries, loading, error } = this.state;

    return (
      <div>
        <Header />

        <div className="container">
          <div className="row">
            <div>&nbsp;</div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <h1 className="photo-index-title">Photography</h1>
            </div>
          </div>

          {loading && (
            <div className="row">
              <div className="col-sm-12 photo-status">
                <div className="photo-spinner" />
                <p>Loading galleries…</p>
              </div>
            </div>
          )}

          {error && (
            <div className="row">
              <div className="col-sm-12 photo-status">
                <p>⚠ {error}</p>
                <p className="photo-error-hint">
                  Run <code>node generate-galleries.js</code> to build the gallery index.
                </p>
              </div>
            </div>
          )}

          {!loading && !error && (
            <div className="row">
              {galleries.map(gallery => (
                <div key={gallery.slug} className="col-sm-12 col-md-6 col-lg-4 mb-4">
                  <Link
                    to={`/photography/${gallery.slug}`}
                    className="photo-card"
                  >
                    <div className="photo-card-img-wrap">
                      <img
                        src={gallery.thumbnail}
                        alt={gallery.title}
                        loading="lazy"
                      />
                      <div className="photo-card-overlay" />
                    </div>
                    <div className="photo-card-info">
                      <h2>{gallery.title}</h2>
                      {gallery.description && <p>{gallery.description}</p>}
                      <span className="photo-card-count">
                        {gallery.images.length} photo{gallery.images.length !== 1 ? 's' : ''}
                      </span>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>

        <Footer />
      </div>
    );
  }
}

export default Photography;
